import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";
import { CTA, Description, Title, Video } from "@/ui";

export const NarrativePanel = ({
  className,
  title,
  description,
  img,
  showCta,
  cta,
  video_embed_url,
  code_iframe,
  reverse,
  bgColor,
  textColor,
}) => {
  return (
    <div>
      <div className={clsx(className, classes.panel, `bg-${bgColor}`)}>
        <Container className="mw-xxl">
          <Row
            className={clsx("flex-column-reverse", {
              "flex-md-row-reverse": reverse,
              "flex-md-row": !reverse,
            })}
          >
            <Col
              xs={12}
              md={video_embed_url || img || code_iframe ? 6 : 12}
              className="d-flex flex-column justify-content-center"
            >
              <div className={clsx(reverse ? "ms-md-5" : "me-md-5", `text-${textColor}`)}>
                <Title title={title} data-sourceflow-prop="title" className={clsx("mb-3")} />
                <Description description={description} data-sourceflow-prop="description" />
                {showCta && (
                  <CTA
                    className="mt-4"
                    label={cta.label}
                    href={cta.href}
                    variant={cta.variant}
                    data-sourceflow-prop="cta"
                  />
                )}
              </div>
            </Col>

            {(video_embed_url || img?.url || code_iframe) && (
              <Col xs={12} md={6} className="d-flex flex-column justify-content-center p-0">
                {video_embed_url ? (
                  <Video video_embed_url={video_embed_url} data-sourceflow-prop="video_embed_url" />
                ) : img?.url ? (
                  <figure className={`mb-4 mb-md-0 ratio ratio-16x9`}>
                    <img
                      src={img.url}
                      className="mw-100 object-fit-cover"
                      alt="Narrative panel image"
                      data-sourceflow-prop="img"
                    />
                  </figure>
                ) : code_iframe ? (
                  <figure className={`mb-4 mb-md-0 ratio ratio-16x9`}>
                    <div dangerouslySetInnerHTML={{ __html: code_iframe }} data-sourceflow-prop="code_iframe" />
                  </figure>
                ) : null}
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default NarrativePanel;
